export default __webpack_public_path__ + "7cfbcf4ad9491f2996f7affa2a48d1a8.woff2";